// initial state
const state = {
  all: [],
}

// getters
const getters = {
}

// actions
const actions = {
  all({ dispatch }) {
    return dispatch(
      'http',
      {
        method: 'GET',
        url: '/fees',
      },
      { root: true },
    )
  },
  one({ dispatch }, id) {
    return dispatch(
      'http',
      {
        method: 'GET',
        url: `/fees/${id}`,
      },
      { root: true },
    )
  },
  async create({ dispatch }, fee) {
    return dispatch(
      'http',
      {
        method: 'POST',
        url: '/fees',
        data: fee,
      },
      { root: true },
    )
  },
  async update({ dispatch }, fee) {
    return dispatch(
      'http',
      {
        method: 'PUT',
        url: `/fees/${fee.feeID}`,
        data: fee,
      },
      { root: true },
    )
  },
  async delete({ dispatch }, fee) {
    return dispatch(
      'http',
      {
        method: 'DELETE',
        url: `/fees/${fee.id}`,
      },
      { root: true },
    )
  },
}

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
